import { render, staticRenderFns } from "./GeneralHomePage.vue?vue&type=template&id=6e16aba8&"
import script from "./GeneralHomePage.vue?vue&type=script&lang=js&"
export * from "./GeneralHomePage.vue?vue&type=script&lang=js&"
import style0 from "./GeneralHomePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports